import { makeStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core/styles/colorManipulator';

import { DIMENSIONS } from '../../../styles/constants';

export const useSliderStyles = makeStyles(theme => ({
	root: {
		width: 'calc(100% - 8px)',
		marginLeft: 4
	},
	mark: {
		backgroundColor: 'inherit'
	},
	trackInverted: {
		'& .MuiSlider-track': {
			backgroundColor: lighten(theme.palette.secondary.main, 1 - 0.38)
		}
	}
}));

export const inputWidth = 98;
export const useStyles = ({ isHorizontal, isRange, spacing }) =>
	makeStyles(theme => {
		const numberOfInputs = spacing || isRange ? 2 : 1;
		const minWidth = inputWidth * numberOfInputs + theme.spacing(numberOfInputs);
		const maxWidth = DIMENSIONS.FILTERS_PANEL_WIDTH - theme.spacing(5);

		return {
			container: {
				width: isHorizontal ? maxWidth + inputWidth * numberOfInputs : maxWidth,
				minWidth: isHorizontal ? minWidth + inputWidth * numberOfInputs : minWidth,
				maxWidth: isHorizontal ? maxWidth + inputWidth * numberOfInputs : maxWidth
			},
			sliderContainer: {
				marginBottom: isHorizontal ? 0 : 4
			}
		};
	});
